import React, {useState} from 'react';
import {Col, Row} from "antd";
import {Button, Card, FormGroup} from "components/ui";
import {FormInput} from "components/ui/form";
import {translate} from "utils/helpers";
import {BiReset, FiFilter} from "react-icons/all";
import {useContactContext} from "context/ContactContext";

function ContactFilter(props) {

    const {translateKey, handleQuery} = useContactContext();
    const initialFilter = {
        fullname: ''
    }
    const [filter, setFilter] = useState(initialFilter);
    const [isFilter, setIsFilter] = useState(false);

    const handleFilter = () => {
        const customQuery = {};
        if (filter.fullname) customQuery.fullname = filter.fullname;
        if (filter.email) customQuery.email = filter.email;
        if (filter.phone) customQuery.phone = filter.phone;
        handleQuery(customQuery);
        setIsFilter(true);
    }

    const handleReset = () => {
        setFilter(initialFilter);
        handleQuery(false);
        setIsFilter(false);
    }

    return (
        <Card className="mb-5">
            <div className="filter-box">
                <div className="flex-1">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={8}>
                            <FormGroup
                                label={translate(translateKey + '.Label.Fullname')}
                            >
                                <FormInput
                                    value={filter.fullname}
                                    onPressEnter={e => e.trim() ? handleFilter() : false}
                                    onChange={e => setFilter(f => ({...f, fullname: e}))}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={24} lg={8}>
                            <FormGroup
                                label={translate(translateKey + '.Label.Email')}
                            >
                                <FormInput
                                    value={filter.email}
                                    onPressEnter={e => e.trim() ? handleFilter() : false}
                                    onChange={e => setFilter(f => ({...f, email: e}))}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={24} lg={8}>
                            <FormGroup
                                label={translate(translateKey + '.Label.Phone')}
                            >
                                <FormInput
                                    value={filter.phone}
                                    onPressEnter={e => e.trim() ? handleFilter() : false}
                                    onChange={e => setFilter(f => ({...f, phone: e}))}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="filter-box-buttons lg:pt-[25px]">
                    <Button
                        disabled={!Object.keys(filter).filter(i => filter[i]?.toString()?.trim()).length}
                        onClick={() => handleFilter()}
                        className="filter-box-button"
                        icon={<FiFilter/>}
                    >
                        {translate( 'button.Filter')}
                    </Button>

                    {isFilter > 0 && (
                        <Button
                            onClick={() => handleReset()}
                            className="filter-box-button"
                            property={'red'}
                            icon={<BiReset/>}
                        >
                            {translate( 'button.Reset')}
                        </Button>
                    )}
                </div>
            </div>
        </Card>
    );
}

export default ContactFilter;
